import { render, staticRenderFns } from "./Desk.vue?vue&type=template&id=3157b504"
import script from "./Desk.vue?vue&type=script&lang=js"
export * from "./Desk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports